module.exports = __webpack_public_path__ + "122960a23bf510db0b518350838dfd2d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/navy-screenprint.png
// module id = 791
// module chunks = 0